export function getDaysInMonth(dateString) {
  // Validate input format (YYYY-MM)
  if (
    typeof dateString !== "string" ||
    !/^\d{4}-(0[1-9]|1[0-2])$/.test(dateString)
  ) {
    throw new Error(
      "Input must be a string in YYYY-MM format (e.g., '2025-04')"
    );
  }

  const [year, month] = dateString.split("-").map(Number);

  // Validate year
  if (!Number.isSafeInteger(year) || year < 1 || year > 9999) {
    throw new Error("Year must be a valid integer between 1 and 9999");
  }

  return new Date(year, month, 0).getDate();
}
